export const isMainDomain = (): boolean => window.location.hostname.split('.')[1] === 'airtm';

export default isMainDomain;
